import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Siren, Package, ChevronRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Red/amber banner: job boxes still not packed. Hot (crew leaves tomorrow/today/overdue) is loud; the rest is a nudge.
export const UnpackedBoxesBanner = ({ compact = false }) => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = () => axios.get(`${API}/tool-crib/alerts/unpacked`).then(r => { if (alive) setData(r.data); }).catch(() => {});
    load();
    const t = setInterval(load, 5 * 60 * 1000);
    return () => { alive = false; clearInterval(t); };
  }, []);
  if (!data || !data.kits?.length) return null;
  const hot = data.kits.filter(k => k.hot);
  const rest = data.kits.filter(k => !k.hot);
  const Row = ({ k }) => (
    <button type="button" onClick={() => navigate(`/tool-crib?kit=${k.id}`)}
      className={`w-full text-left flex items-center gap-2 rounded-lg px-3 py-2 ${k.hot ? 'bg-red-600 text-white hover:bg-red-500' : 'bg-white text-amber-900 hover:bg-amber-100 border border-amber-300'}`}
      data-testid={`unpacked-box-${k.id}`}>
      {k.hot ? <Siren className="w-4 h-4 shrink-0 animate-pulse" /> : <Package className="w-4 h-4 shrink-0" />}
      <span className="flex-1 min-w-0">
        <span className="block text-sm font-bold leading-tight break-words">{k.headline}</span>
        {!compact && <span className={`block text-xs ${k.hot ? 'text-red-100' : 'text-amber-800'}`}>{k.kit_number} · {k.packed_count ? `${k.packed_count}/${k.item_count} items packed` : `${k.item_count} items, nothing packed yet`}{k.requested_by_name ? ` · requested by ${k.requested_by_name}` : ''}{k.unpacked_alerts?.count ? ` · nagged ${k.unpacked_alerts.count}×` : ''}</span>}
      </span>
      <ChevronRight className="w-4 h-4 shrink-0" />
    </button>
  );
  return (
    <div className={`rounded-2xl p-3 space-y-2 ${hot.length ? 'bg-red-50 border-2 border-red-500' : 'bg-amber-50 border border-amber-300'}`} data-testid="unpacked-boxes-banner">
      <p className={`text-xs font-extrabold uppercase tracking-wider ${hot.length ? 'text-red-700' : 'text-amber-800'}`}>
        {hot.length ? `${hot.length} job box${hot.length === 1 ? '' : 'es'} NOT PACKED — crew leaving` : `${rest.length} job box${rest.length === 1 ? '' : 'es'} waiting to be packed`}
      </p>
      {hot.map(k => <Row key={k.id} k={k} />)}
      {rest.slice(0, compact ? 2 : 6).map(k => <Row key={k.id} k={k} />)}
      {rest.length > (compact ? 2 : 6) && <p className="text-xs text-amber-800">+{rest.length - (compact ? 2 : 6)} more in Tool Crib</p>}
    </div>
  );
};
